import React, { Component } from "react";
import { GET, POST, loading, alert, t } from "../components/CustomComponent.js";
import { getProfile } from "../utils/localStorage.js";
import Logo from "../components/Logo.js";
import { rememberLineLinked, forgetLineLinked } from "../utils/lineLogin.js";
import "../assets/css/bootstrap.css";
import "../assets/css/style.css";
import "../assets/css/login.css";

// หน้ารับผลกลับจาก LINE — LINE จะ redirect มาที่นี่พร้อม code/state
// ต้องตรงกับ LINE_LOGIN_REDIRECT_URI ฝั่ง backend และที่ลงทะเบียนไว้ใน LINE Developers Console

// หน้าแรกหลังเข้าระบบคิดจากสิทธิ์ของบทบาท ไม่ยิงไปแดชบอร์ดตายตัว (global.getAdminHomeLink)
const LOGIN_LINK = "/login";

export default class LineCallback extends Component {
  constructor(props) {
    super(props);
    this.state = {
      // verifying = กำลังคุยกับ backend, link = ต้องยืนยันรหัสผ่านก่อนผูก, error = จบแบบไม่สำเร็จ
      step: "verifying",
      message: "",
      password: "",
      password_view: "password",
      email: "",
      full_name: "",
      link_ticket: "",
      line_display_name: "",
      line_picture: "",
    };
    // code ของ LINE ใช้ได้ครั้งเดียว — กันยิงซ้ำถ้า component ถูก mount สองรอบ
    this.exchanged = false;
  }

  async componentDidMount() {
    if (this.exchanged) return;
    this.exchanged = true;

    const query = new URLSearchParams(window.location.search);
    const code = query.get("code");
    const state = query.get("state");
    const error = query.get("error");

    // ผู้ใช้กดยกเลิกที่หน้ายินยอมของ LINE
    if (error || !code || !state) {
      loading(false);
      this.setState({ step: "error", message: query.get("error_description") || t("line_login_cancelled") });
      return;
    }

    loading(true);
    const result = await POST("auth/line/callback", { code, state });

    // POST เด้ง popup แจ้ง error ให้แล้ว ที่นี่แค่ค้างหน้าไว้ให้กดกลับไปหน้าเข้าสู่ระบบ
    if (result?.status !== true) {
      loading(false);
      this.setState({ step: "error", message: result?.message || "" });
      return;
    }

    const data = result.data || {};

    // เดาว่าเบราว์เซอร์นี้ผูกไว้แล้วเลยข้ามหน้ายินยอมไป แต่ที่จริงยังไม่ผูก — ต้องกลับไปยินยอมอีกรอบ
    // ลืมค่าที่จำไว้ด้วย จะได้ไม่เดาผิดซ้ำแล้วต้องวิ่งไป LINE สองรอบทุกครั้ง
    if (data.need_consent && data.authorize_url) {
      forgetLineLinked();
      window.location.href = data.authorize_url;
      return;
    }

    // ยังไม่เคยผูก แต่พบผู้ใช้ที่อีเมลตรงกัน — ต้องยืนยันรหัสผ่านก่อนถึงจะผูกให้
    if (data.need_link) {
      loading(false);
      this.setState({
        step: "link",
        link_ticket: data.link_ticket,
        email: data.email || "",
        full_name: data.full_name || "",
        line_display_name: data.line_display_name || "",
        line_picture: data.line_picture || "",
      });
      return;
    }

    // ผูกจากหน้าโปรไฟล์ (ยังถือ token เดิมอยู่) — ไม่มี token ใหม่ส่งกลับมา
    if (!data.token) {
      rememberLineLinked();
      loading(false);
      await alert("", "success", t("success"), t("line_linked_success"));
      // ผูกจากหน้าโปรไฟล์ = ล็อกอินอยู่ก่อนแล้ว จึงใช้โปรไฟล์ที่เก็บไว้คิดหน้าปลายทางได้เลย
      window.location.href = global.getAdminHomeLink(getProfile());
      return;
    }

    await this.EnterSystem(data.token);
  }

  // เก็บ token แล้วดึงโปรไฟล์ให้ครบก่อนเข้าระบบ เหมือน flow ของหน้าเข้าสู่ระบบปกติ
  // เพราะ PermissionRoute และเมนูฝั่งซ้ายอ่านสิทธิ์จาก mn-profile
  EnterSystem = async (token) => {
    // มาถึงขั้นนี้แปลว่าบัญชี LINE ผูกกับผู้ใช้เรียบร้อยแล้ว — ครั้งหน้าขอข้ามหน้ายินยอมได้เลย
    rememberLineLinked();
    localStorage.setItem("mn-acc-tk", btoa("Bearer " + token));

    const profile = await GET("admin/users/profile");
    if (profile?.status !== true) {
      localStorage.clear();
      loading(false);
      this.setState({ step: "error", message: profile?.message || "" });
      return;
    }

    localStorage.setItem("mn-profile", JSON.stringify(profile.data));
    window.location.href = global.getAdminHomeLink(profile.data);
  };

  ConfirmLink = async () => {
    const { password, link_ticket } = this.state;

    if (!password) return alert("", "warning", t("warning"), t("verify_password"));

    loading(true);
    // backend ถอด base64 ก่อนเทียบรหัสผ่าน จึงต้องส่งแบบเข้ารหัสไว้เหมือน /auth/login
    const result = await POST("auth/line/link", { link_ticket, password: btoa(password) });

    if (result?.status !== true) {
      loading(false);
      return;
    }

    await this.EnterSystem(result.data.token);
  };

  render() {
    const { step, message, password, password_view, email, full_name, line_display_name, line_picture } = this.state;

    return (
      <div className="mn-login mn-login--single">
        <div className="mn-login__form-side">
          <div className="mn-login__topbar">
            <Logo size={42} />
          </div>

          <div className="mn-login__body">
            {step === "verifying" && (
              <>
                <h1 className="mn-login__title">{t("line_verifying_title")}</h1>
                <p className="mn-login__subtitle">{t("line_verifying_subtitle")}</p>
              </>
            )}

            {step === "link" && (
              <>
                <h1 className="mn-login__title">{t("line_link_title")}</h1>
                <p className="mn-login__subtitle">{t("line_link_subtitle")}</p>

                <div className="mn-line-account">
                  {line_picture ? (
                    <img className="mn-line-account__avatar" src={line_picture} alt="" />
                  ) : (
                    <span className="mn-line-account__avatar mn-line-account__avatar--empty">LINE</span>
                  )}
                  <div className="mn-line-account__info">
                    <p className="mn-line-account__name">{line_display_name || "LINE"}</p>
                    <p className="mn-line-account__email">{full_name ? `${full_name} · ${email}` : email}</p>
                  </div>
                </div>

                <div className="mn-field">
                  <span className="mn-field__icon icon">{""}</span>
                  <input
                    type={password_view}
                    className="mn-field__input"
                    placeholder={t("password")}
                    value={password}
                    autoFocus
                    onChange={(e) => this.setState({ password: e.target.value })}
                    onKeyUp={(e) => e.key === "Enter" && this.ConfirmLink()}
                  />
                  <button
                    type="button"
                    className="mn-field__toggle"
                    aria-label={t("password")}
                    onClick={() =>
                      this.setState({
                        password_view: password_view === "password" ? "text" : "password",
                      })
                    }
                  >
                    <span className="icon">{password_view === "password" ? "" : ""}</span>
                  </button>
                </div>

                <button className="mn-btn mn-btn--primary" onClick={this.ConfirmLink}>
                  {t("line_link_confirm")}
                </button>

                <button className="mn-link mn-link--block" onClick={() => (window.location.href = LOGIN_LINK)}>
                  {t("back_to_login")}
                </button>
              </>
            )}

            {step === "error" && (
              <>
                <h1 className="mn-login__title">{t("line_login_failed_title")}</h1>
                <p className="mn-login__subtitle">{message || t("line_login_failed_subtitle")}</p>

                <button className="mn-btn mn-btn--primary" onClick={() => (window.location.href = LOGIN_LINK)}>
                  {t("back_to_login")}
                </button>
              </>
            )}
          </div>

          <div className="mn-login__footer">
            <div>© {new Date().getFullYear()} SafeSpace Life Living Co., Ltd.</div>
            <div>
              {t("all_rights_reserved")} · v{global.version}
            </div>
          </div>
        </div>
      </div>
    );
  }
}
